<template>
  <div id="app">
    <div v-if="loading" class="spinner-overlay">
      <b-spinner variant="light" label="Loading…" />
    </div>
    <router-view />
    <portal-target name="aiv-portals" multiple />
  </div>
</template>

<script>
import { useSpinnerStore } from "src/stores/spinner";

export default {
  name: "App",
  computed: {
    loading() {
      return useSpinnerStore().active;
    },
  },
};
</script>

<style>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.client-modal {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  z-index: 2000 !important;
}

.client-modal .el-dialog {
  margin: 0 !important;
  transform: none !important;
}
</style>
